import { createSlice } from "@reduxjs/toolkit";

import {
  sopModuleReducer,
  createSopModuleListAction,
  deleteSingleSopDetailsAction,
  getSingleSopDetailsAction,
  getSopModuleListAction,
  getUniqueCheckSopFileNameAction,
  hideUnhideSopAction,
  updateSopModuleAction,
  initialState,
} from "@/redux/sopModule";
import type { SopModuleType } from "@/redux/sopModule/sopTypes";

export const sopModuleSlice = createSlice({
  name: "sopModule",
  initialState,
  reducers: sopModuleReducer,

  extraReducers: (builder) => {
    builder.addCase(
      createSopModuleListAction.pending,
      (state: SopModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createSopModuleListAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success: success,
          message: message,
        };
      }
    );

    builder.addCase(
      createSopModuleListAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(updateSopModuleAction.pending, (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      updateSopModuleAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { success, status_code, message } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            success: success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success: success,
          message: message,
        };
      }
    );

    builder.addCase(
      updateSopModuleAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(getSopModuleListAction.pending, (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      getSopModuleListAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { status_code, result, message, success } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          sopModuleList: result?.data,
          sopModuleTotalCount: result?.total_count,
          message,
        };
      }
    );

    builder.addCase(
      getSopModuleListAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getSingleSopDetailsAction.pending,
      (state: SopModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getSingleSopDetailsAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          sopModuleList: result,
          statusCode: status_code,
          singleSopDetails: result,
          message,
        };
      }
    );

    builder.addCase(
      getSingleSopDetailsAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getUniqueCheckSopFileNameAction.pending,
      (state: SopModuleType) => ({
        ...state,
        uniqueCheckFileNameFetching: true,
      })
    );

    builder.addCase(
      getUniqueCheckSopFileNameAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            uniqueCheckFileNameFetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          uniqueCheckFileNameFetching: false,
          statusCode: status_code,
          uniqueCheckFileNameMessage: message,
        };
      }
    );

    builder.addCase(
      getUniqueCheckSopFileNameAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        uniqueCheckFileNameFetching: false,
      })
    );

    builder.addCase(
      deleteSingleSopDetailsAction.pending,
      (state: SopModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteSingleSopDetailsAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          message: message,
          success: success,
        };
      }
    );

    builder.addCase(
      deleteSingleSopDetailsAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(hideUnhideSopAction.pending, (state: SopModuleType) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      hideUnhideSopAction.fulfilled,
      (state: SopModuleType, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message: message,
        };
      }
    );

    builder.addCase(
      hideUnhideSopAction.rejected,
      (state: SopModuleType, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );
  },
});
export const {
  resetSopModuleError,
  resetSopModuleSuccess,
  resetSopModuleFetching,
  resetSopModuleMessage,
  resetSopModuleListing,
  resetSopModuleListTotal,
  resetSopModuleStatusCode,
  resetSingleSopDetails,
  resetUniqueCheckFileNameMessage,
} = sopModuleSlice.actions;
